exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--6-1!../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!vue-good-table/dist/vue-good-table.css"), "");

// module
exports.push([module.id, "\n.table-div[data-v-73128d48] {\n  overflow: scroll;\n  height: 600px;\n}\n.fabric-action span[data-v-73128d48] {\n  background: #767676;\n  color: #fff;\n  border-radius: 50%;\n  display: inline-block;\n  width: 20px;\n  text-align: center;\n  cursor: pointer;\n}\n.action-cell[data-v-73128d48] {\n  width: 50px;\n}\n.bulk-fabric-action[data-v-73128d48] {\n  margin-top: 25px;\n}\n", ""]);

// exports
